import React from 'react';
import {IconInformation, Subtitle} from '@/components/atoms';
import {Wrapper, TitleWrapper} from './PromoFooter.styled';
import {IPromotionDetail} from "@/types";

interface IProps extends IPromotionDetail {
  onClickCertificate?: () => void;
}

const PromoFooter = (props: IProps) => {
  const {proFooterTitle, proFooterInformation, finBrokerCertPath, onClickCertificate} = props;

  return (
    <Wrapper>
      <TitleWrapper>
        <IconInformation width={20} color="primary-100"/>
        <Subtitle level={3} color="gray-800">
          {proFooterTitle}
        </Subtitle>
      </TitleWrapper>
      <Subtitle level={8} color="gray-700" whiteSpaceWrap>
        <div dangerouslySetInnerHTML={{__html: proFooterInformation}}></div>
        {
          finBrokerCertPath &&
            <div style={{marginTop: '1rem'}} onClick={onClickCertificate}>
                <Subtitle level={5} color='gray-700'>금융상품 판매대리 &middot; 중개업자 증서 보기 &gt; </Subtitle>
            </div>
        }
      </Subtitle>
    </Wrapper>
  );
};

export default PromoFooter;
